module.exports = "/static/assets/063892ef24eec57459ee932cec7e12e5.png";